/** Caps for workspace list-view walks (matches prior fetchAllPages bounds). */
export const LIST_VIEW_PER_PAGE = 100;
export const LIST_VIEW_MAX_PAGES = 20;

/**
 * Reduce one list-view envelope into paging state.
 * Prefer cursor when present; otherwise page++ until short page or empty.
 */
export function reduceListViewPage(state, env, perPage = LIST_VIEW_PER_PAGE) {
    const list = Array.isArray(env?.data) ? env.data : [];
    const total =
        state.total != null
            ? state.total
            : (env?.meta?.total != null ? Number(env.meta.total) : null);
    const items = state.items.concat(list);
    if (!list.length) {
        return { items, total, page: state.page, cursor: null, done: true };
    }
    const nextCursor = env?.meta?.next_cursor || null;
    if (nextCursor) {
        return { items, total, page: state.page, cursor: nextCursor, done: false };
    }
    if (list.length < perPage) {
        return { items, total, page: state.page, cursor: null, done: true };
    }
    if (state.cursor) {
        return { items, total, page: state.page, cursor: null, done: true };
    }
    return { items, total, page: state.page + 1, cursor: null, done: false };
}

export function listViewInitialState() {
    return { items: [], total: null, page: 1, cursor: null, done: false };
}
